import FormatChange, { FormatMonitorMedia } from 'formatchange';

type GroupFlags =
	| 'isHamburger'
	| 'wasHamburger'
	| 'becameHamburger'
	| 'leftHamburger'
	| 'isTopmenu'
	| 'wasTopmenu'
	| 'becameTopmenu'
	| 'leftTopmenu';

const formatMonitor =
	FormatChange &&
	new FormatChange<GroupFlags>({
		Hamburger: {
			phone: true,
			phablet: true,
			tablet: true,
		},
		Topmenu: {
			netbook: true,
			// desktop: true,
			wide: true,
		},
	});

export default formatMonitor;

export type MediaFormat = FormatMonitorMedia<GroupFlags>;
